import axios from "axios";


export const customerData = async (userId) => {
    return await axios.get(`${process.env.REACT_APP_HOST}/api/customer/all/${userId}`);
};

export const executiveData = async () => {
    try {
        const company = JSON.parse(localStorage.getItem("companyDetails") || "{}");
        const regId = company?.id;
        if (regId) {
            return await axios.get(`${process.env.REACT_APP_HOST}/api/executive/all/${regId}`);
        }
        return await axios.get(`${process.env.REACT_APP_HOST}/executives`);
    } catch (e) {
        return await axios.get(`${process.env.REACT_APP_HOST}/executives`);
    }
};


export const ordersData = async (userId) => {
    return await axios.get(`${process.env.REACT_APP_HOST}/api/orders/getAll/${userId}`);
};
export const productData = async (userId, includeImage = false) => {
    const includeImageParam = includeImage ? "true" : "false";
    return await axios.get(`${process.env.REACT_APP_HOST}/api/Products/getAll/${userId}?includeImage=${includeImageParam}`);
};
export const purchaseData = async (userId) => {
    return await axios.get(`${process.env.REACT_APP_HOST}/api/Purchases/getall/${userId}`);
};
export const incentiveData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/incentives`);
};


export const companyData = async () => {
    return await axios.get(`${process.env.REACT_APP_HOST}/companies`);
};

export const categoryData = async (userId) => {
    return await axios.get(`${process.env.REACT_APP_HOST}/api/Products/categories/${userId}`);
};

export const addCustomer = async (data) => {
    return await axios.post(`https://capi.2kvirtualworld.com/b2bfastbilling/api/customer/add`, data);
};

export const updateCustomer = async (registerId, customerId, data) => {
    return await axios.put(`https://capi.2kvirtualworld.com/b2bfastbilling/api/customer/update/${registerId}/${customerId}`, data);
};

// Quantity Types API
export const addQuantityType = async (data) => {
    return await axios.post(`https://capi.2kvirtualworld.com/b2bfastbilling/api/QuantityTypes/add`, data);
};

export const getAllQuantityTypes = async (userId) => {
    return await axios.get(`https://capi.2kvirtualworld.com/b2bfastbilling/api/QuantityTypes/all/${userId}`);
};

export const updateQuantityType = async (userId, id, data) => {
    return await axios.put(`https://capi.2kvirtualworld.com/b2bfastbilling/api/QuantityTypes/${userId}/${id}`, data);
};

export const deleteQuantityType = async (userId, id) => {
    return await axios.delete(`https://capi.2kvirtualworld.com/b2bfastbilling/api/QuantityTypes/${userId}/${id}`);
};